import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "preview", "deleteFlag"]
    declare readonly inputTarget: HTMLInputElement
    declare readonly previewTarget: HTMLInputElement
    declare readonly deleteFlagTarget: HTMLInputElement
    declare readonly hasDeleteFlagTarget: boolean

    showInput(event:any) {
        event.preventDefault()

        // 1. Reveal the hidden file input
        this.inputTarget.style.display = "block"

        // 2. Hide the current image thumbnail
        this.previewTarget.style.display = "none"

        // 3. Ensure the delete flag is NOT triggered
        // This tells the model: "I'm not deleting, I'm updating."
        if (this.hasDeleteFlagTarget) {
            this.deleteFlagTarget.value = "0"
        }
    }

}